'use strict';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  STATES: {},
  AVATARS: [],
  CUSTOMERS: [],
  AGENTS: [],
  SUPERVISORS: [],
  BUSINESS_PROCESSES: [],
  CHANNELS: [],
  CRM_CONTACTS: [], // NOTE: It stores only the CRM contacts that are being used in active/historical interaction(s) and/or are favorites
  CRM_TEMPLATES: [],
  ENTERPRISE: [],
  EXTERNAL: [],
  FAVORITES: { internal: [], external: [], favorites: [] }
};

export default {
  namespaced: true,

  /**
   * As a best practice: Actions call mutations which update our current state
   * Actions could execute sync or async operations.
   */
  actions,

  /**
   * Access to state values
   */
  getters,

  /**
   * Used to commit and track state changes
   * Mutations should always execute sync operations.
   */
  mutations,

  /**
   * Single source of truth
   */
  state
};
